import { Sun, Moon } from "lucide-react";
import { useAppTheme } from "@/context/AppThemeContext";

export const ThemeToggle = ({ className = "" }) => {
  const { mode, toggleMode } = useAppTheme();
  return (
    <button
      onClick={toggleMode}
      className={`p-2 rounded-full transition-all hover:bg-muted ${className}`}
      data-testid="theme-toggle"
      title={mode === 'light' ? 'Dark mode' : 'Light mode'}
    >
      {mode === 'light' ? <Moon size={18} className="text-muted-foreground" /> : <Sun size={18} className="text-yellow-400" />}
    </button>
  );
};
